import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("omni_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("omni_token"))
      .finally(() => setLoading(false));
  }, []);

  // Step 1 — verify password. Returns { twofa: true, ... } when a 2FA step is
  // required (which is always, since 2FA is mandatory), otherwise logs in.
  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.twofa_required) {
      return { twofa: true, ...data };
    }
    localStorage.setItem("omni_token", data.token);
    setUser(data.user);
    return { twofa: false, user: data.user };
  };

  // Step 2 — verify the TOTP (or backup) code and complete login.
  const verifyTwofa = async (challenge, code) => {
    const { data } = await api.post("/auth/2fa/verify", { challenge, code });
    localStorage.setItem("omni_token", data.token);
    setUser(data.user);
    return data; // { token, user, backup_codes?, backup_code_used?, backup_codes_remaining? }
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("omni_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("omni_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, verifyTwofa, register, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
